import { render, staticRenderFns } from "./ArticleHeader.vue?vue&type=template&id=6510a60e&scoped=true"
import script from "./ArticleHeader.vue?vue&type=script&lang=js"
export * from "./ArticleHeader.vue?vue&type=script&lang=js"
import style0 from "./ArticleHeader.vue?vue&type=style&index=0&id=6510a60e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@6.26.3_cache-loader@4.1.0_webpac_ddacfd63a0804571a953918ce6bcb0d4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6510a60e",
  null
  
)

export default component.exports